import React from 'react';
import { Tag } from 'antd';

const AdminExclusiveTag = () => (
    <Tag color="red" className="x-small-text bottom-spacing-3">
        ADMIN EXCLUSIVE
    </Tag>
);

export default AdminExclusiveTag;